import React, { useEffect } from 'react';
import { PACKAGES } from '../mock';
import { Check, ChevronRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import fbTrack from '../lib/fbpixel';

export default function PackagesSection({ onBook }) {
  useEffect(() => {
    // Fire ViewContent when user actually reaches the packages section
    let fired = false;
    const el = document.getElementById('packages');
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting && !fired) {
          fired = true;
          fbTrack.viewContent('Service Packages', 3999);
          obs.disconnect();
        }
      });
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="packages" className="relative py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <div className="section-title-eyebrow uppercase">Our Packages</div>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold">
            <span className="text-white">અમારા </span><span className="gradient-text">સર્વિસ પેકેજો</span>
          </h2>
          <p className="mt-4 text-gray-400">તમારી જરૂરિયાત મુજબ પેકેજ પસંદ કરો — બન્ને પેકેજ માટે ફ્રી પિકઅપ & ડ્રોપ.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {PACKAGES.map(p => (
            <div key={p.id} className={`relative card-dark p-7 flex flex-col ${p.tag ? 'border-pink-500/40' : ''}`}>
              {p.tag && (
                <div className="absolute -top-3 left-6 tag-pill"><Sparkles className="w-3 h-3" /> {p.tag}</div>
              )}
              <h3 className="text-xl font-extrabold text-white">{p.name}</h3>
              <div className="text-xs tracking-widest text-gray-400 mt-1">{p.subtitle}</div>

              <div className="mt-5 flex items-baseline gap-3">
                <div className="text-4xl font-extrabold gradient-text">₹{p.offerPrice.toLocaleString()}</div>
                <div className="text-sm text-gray-400">+ GST</div>
              </div>
              <div className="mt-1 flex items-center gap-2 text-sm">
                <span className="text-gray-500 line-through">₹{p.marketPrice.toLocaleString()}</span>
                <span className="text-green-400 font-semibold">{p.savings}% બચત</span>
              </div>

              <ul className="mt-5 space-y-2.5 flex-1">
                {p.services.slice(0, 10).map((s, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-200">
                    <Check className="w-4 h-4 text-pink-400 mt-0.5 shrink-0" />
                    <span>{s}</span>
                  </li>
                ))}
                {p.services.length > 10 && (
                  <li className="text-sm text-gray-400 pl-6">+ {p.services.length - 10} વધુ સર્વિસ</li>
                )}
              </ul>

              <div className="mt-5 text-xs text-gray-400 border-t border-purple-900/40 pt-4">{p.applicable}</div>
              <Button onClick={() => onBook(p.id)} className="gradient-btn rounded-full h-11 mt-5 w-full font-semibold">
                પેકેજ બુક કરો <ChevronRight className="w-4 h-4 ml-1" />
              </Button>
            </div>
          ))}
        </div>

        <div className="mt-6 text-center text-sm text-gray-400">
          * બધા ભાવમાં GST અલગથી લાગુ પડશે. ડીઝલ કાર ની કિમતમાં <span className="text-pink-400 font-semibold">₹1,500+</span> પ્લસ થશે.
        </div>
      </div>
    </section>
  );
}
